small
<template>
  <validation-provider
    #default="{ errors }"
    :name="defaultName"
    mode="passive"
    :rules="rules"
  >
    <b-form-group :description="description" :label="label" :label-for="id">
      <b-input-group dir="rtl" class="input-group-merge">
        <b-form-input
          :state="
            $attrs.state || errors.length > 0
              ? false
              : withValidation && $attrs.value
              ? true
              : null
          "
          :name="name"
          :id="id"
          v-bind="$attrs"
          :type="isPassword ? 'password' : 'text'"
          v-on="$listeners"
        />
        <b-input-group-append is-text>
          <feather-icon
            class="cursor-pointer"
            @click="isPassword = !isPassword"
            :icon="isPassword ? 'EyeIcon' : 'EyeOffIcon'"
          />
        </b-input-group-append>
      </b-input-group>

      <small class="text-danger">{{ errors[0] }}</small>
    </b-form-group>
  </validation-provider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import {
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import { required, confirmed, password, min } from "@validations";
export default {
  components: {
    ValidationProvider,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
  },
  props: {
    id: {
      type: String,
      default: () => "input",
    },
    name: {
      type: String,
    },
    rules: {
      type: String,
      default: () => "",
    },
    label: {
      type: String,
      default: () => "",
    },
    description: {
      type: String,
      default: () => "",
    },
    withValidation: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      required,
      confirmed,
      password,
      min,
      isPassword: true,
    };
  },
  computed: {
    defaultName() {
      return this.name || this.label;
    },
  },
};
</script>
